import { colors } from 'component-library/styles/colors';
import { device } from 'component-library/styles/device';
import styled from 'styled-components';

interface PageWrapperProps {
  background?: string;
}

export const PageWrapper = styled.main<PageWrapperProps>`
  background: ${({ background = colors.white }) => background};
  margin-top: 65px;

  ${`@media ${device.xl}`} {
    margin-top: 89px;
  }
`;
